module.exports = __webpack_public_path__ + "assets/img/modal-avatar-ca7a2391.png";